import Dashboard from "../dashboard/Dashboard";
import EmployeeDashboard from "../dashboard/EmployeeDashboard";

const dashboardRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/employee/dashboard", component: EmployeeDashboard },
];

export default dashboardRoutes;
